import Vue from 'vue'
import VueRouter from 'vue-router'
import jwtDecode from 'jwt-decode'

import AppLayout from '@/views/layouts/AppLayout.vue'
import AdminLayout from '@/views/layouts/AdminLayout.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '/login',
      name: 'Login',
      meta: {
        requiresAuth: false
      },
      component: () => import('@/views/auth/LoginPage.vue')
    },
    {
      path: '/forgotPassword',
      name: 'ForgotPassword',
      meta: {
        requiresAuth: false
      },
      component: () => import('@/views/auth/ForgotPasswordPage.vue')
    },
    {
      path: '/reset/:passwordResetToken?',
      name: 'ResetPassword',
      meta: {
        requiresAuth: false
      },
      component: () => import('@/views/auth/ResetPasswordPage.vue')
    },
    {
      path: '/network',
      name: 'Network',
      meta: {
        requiresAuth: false,
        roles: [ ]
      },
      component: () => import('@/views/home/NetworkConnection.vue')
    },
    {
      path: '/',
      component: AppLayout,
      redirect: { name: 'Home' },
      meta: {
        requiresAuth: false,
        roles: [ ]
      },
      children: [
        {
          path: '',
          name: 'Home',
          meta: {
            requiresAuth: true,
            roles: [ 'Administrator', 'Student', 'Instructor' ]
          },
          component: () => import('@/views/home/Home.vue')
        },
        {
          path: '/help',
          name: 'Help',
          meta: {
            requiresAuth: false,
            roles: [ ]
          },
          component: () => import('@/views/home/HelpPage.vue')
        },
        {
          path: '/courses',
          name: 'PastCourses',
          meta: {
            requiresAuth: true,
            roles: [ 'Administrator', 'Student', 'Instructor' ]
          },
          component: () => import('@/views/home/PastCoursesPage.vue')
        },
        {
          path: '/course-details/:id',
          name: 'CourseDetails',
          meta: {
            requiresAuth: true,
            roles: [ 'Administrator', 'Student', 'Instructor' ]
          },
          component: () => import('@/views/home/CoursePage.vue')
        },
        {
          path: '/edit-profile',
          name: 'EditProfile',
          meta: {
            requiresAuth: true,
            roles: [ 'Administrator', 'Student', 'Instructor' ]
          },
          component: () => import('@/views/home/EditProfilePage.vue')
        },
        {
          path: '/instructor-surveys',
          name: 'InstructorSurveys',
          meta: {
            requiresAuth: true,
            roles: [ 'Instructor' ]
          },
          component: () => import('@/views/home/InstructorSurveysPage.vue')
        }
      ]
    },
    {
      path: '/admin',
      name: 'Admin',
      meta: {
        requiresAuth: true,
        roles: [ 'Administrator' ]
      },
      component: AdminLayout,
      redirect: { name: 'Dashboard' },
      children: [
        {
          path: 'settings',
          name: 'Settings',
          meta: {
            requiresAuth: true,
            roles: [ 'Administrator' ]
          },
          component: () => import('@/views/admin/Settings.vue')
        },
        {
          path: 'students',
          name: 'Students',
          meta: {
            requiresAuth: true,
            roles: [ 'Administrator' ]
          },
          component: () => import('@/views/admin/students/StudentsPage.vue')
        },
        {
          path: '',
          name: 'Dashboard',
          meta: {
            requiresAuth: true,
            roles: [ 'Administrator' ]
          },
          component: () => import('@/views/admin/Dashboard.vue')
        },
        {
          path: 'users',
          name: 'Users',
          meta: {
            requiresAuth: true,
            roles: [ 'Administrator' ]
          },
          component: () => import('@/views/admin/users/UsersPage.vue')
        },
        {
          path: 'surveys',
          name: 'Surveys',
          meta: {
            requiresAuth: true,
            roles: [ 'Administrator' ]
          },
          component: () => import('@/views/admin/surveys/Index.vue')
        },
        {
          path: 'user/:id',
          name: 'User',
          meta: {
            requiresAuth: true,
            roles: [ 'Administrator' ]
          },
          component: () => import('@/views/admin/users/UserPage.vue')
        },
        {
          path: 'courses',
          name: 'Courses',
          meta: {
            requiresAuth: true,
            roles: [ 'Administrator' ]
          },
          component: () => import('@/views/admin/courses/CoursesPage.vue')
        },
        {
          path: 'course/:id',
          name: 'Course',
          meta: {
            requiresAuth: true,
            roles: [ 'Administrator' ]
          },
          component: () => import('@/views/admin/courses/CoursePage.vue')
        },
        {
          path: 'frame',
          name: 'Frame',
          meta: {
            requiresAuth: true,
            roles: [ 'Administrator' ]
          },
          component: () => import('@/views/admin/frame/FramePage.vue')
        },
        {
          path: 'import',
          name: 'Import',
          meta: {
            requiresAuth: true,
            roles: [ 'Administrator' ]
          },
          component: () => import('@/views/admin/courses/ImportPage.vue')
        },
        {
          path: '/edit-user-profile/:id',
          name: 'EditUserProfile',
          meta: {
            requiresAuth: true,
            roles: [ 'Administrator' ]
          },
          component: () => import('@/views/home/EditProfilePage.vue')
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    // also check for expiry token
    // redirect to login page if not logged in and trying to access a restricted page
    var currentUser = JSON.parse(localStorage.getItem('currentUser'))
    if (currentUser && to.matched.some(record => record.meta.roles.some(role => currentUser.roles.includes(role))) && Date.now() < jwtDecode(currentUser.token).exp * 1000) {
      next()
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router
